var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileTypeZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 16C1.11667 16 0.770833 15.8458 0.4625 15.5375C0.154167 15.2292 0 14.8833 0 14.5V1.5C0 1.11667 0.154167 0.770833 0.4625 0.4625C0.770833 0.154167 1.11667 0 1.5 0H8.5L10 1.5H18.5C18.8833 1.5 19.2292 1.65417 19.5375 1.9625C19.8458 2.27083 20 2.61667 20 3V14.5C20 14.8833 19.8458 15.2292 19.5375 15.5375C19.2292 15.8458 18.8833 16 18.5 16H1.5ZM14 14.5H18.5V3H14V5.3H16.3V7.6H14V9.9H16.3V12.2H14V14.5ZM1.5 14.5H11.7V12.2H14V9.9H11.7V7.6H14V5.3H11.7V3H9.375L7.875 1.5H1.5V14.5ZM1.5 3V1.5V14.5V3Z",
    fill: "#2C2D3E",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypeZip);
export default __webpack_public_path__ + "static/media/file-type-zip.98c3978afeb15d49aec6aeccb29b5f20.svg";
export { ForwardRef as ReactComponent };